module.exports = __webpack_public_path__ + "img/dani-diez-desert-seeker.83f4519.jpg";